export default "__VITE_ASSET__cUuOd0bH__"